// extracted by mini-css-extract-plugin
export var container = "_ts-0";
export var table = "_ts-2";
export var tableWrapper = "_ts-1";